import logo from './logo.svg';
import './App.css';
import Navbar from './Component/Navbar';
import HeroSection from './Component/HeroSection';
import WhyChooseUs from './Component/WhyChooseUs';
import StatsSection from './Component/StatsSection';
import FeaturesGrid from './Component/FeaturesGrid';
import ServicesSection from './Component/ServicesSection';
import HowItWorksSection from './Component/HowItWorksSection';
import RatesSection from './Component/RatesSection';
import WhyTrustUsSection from './Component/WhyTrustUsSection';//TestimonialsSection
import TestimonialsSection from './Component/TestimonialsSection';//LocationsSection
import LocationsSection from './Component/LocationsSection';//FAQSection
import FAQSection from './Component/FAQSection';//c
import ContactSection from './Component/ContactSection';//Footer
import Footer from './Component/Footer';//Footer
import AdCard from './Component/AdCard';//Footer








function App() {
  return (
    <div className="App">
      <Navbar/>
      <HeroSection/>
      <StatsSection/>
      <AdCard/>
       <FeaturesGrid/>
       <ServicesSection/>
       <HowItWorksSection/>
       {/* <RatesSection/> */}
       <WhyTrustUsSection/>
       <TestimonialsSection/>
       <LocationsSection/>
       <FAQSection/>
       <ContactSection/>
       <Footer/>

    </div>
  );
}

export default App;
